import BaseService from "./BaseService";
import {extend} from "vue-router/src/util/misc";

export default class StoreService extends BaseService{

    async getStoreList(data){
       const url = this.API.store.getStoreList;
       let result =  await this.get(url, data);
       return result;
    }

    async getStoreDetail(data){
        const url = this.API.store.getStoreDetail;
        let result = await this.get(url, data);
        return  result;
    }

    async getStoreDetailByFriendlyUrl(data){
       const url = this.API.store.getStoreDetailByFriendlyUrl;
       let result = await this.get(url,data);
       return result;
    }
}




// WEBPACK FOOTER //
// ./src/service/services/StoreService.js